(() => {
  let parallaxFrame = 0;
  let parallaxBound = false;
  function init(root = document) {
    root.querySelectorAll('.nv-menu-toggle').forEach(toggle => {
      if (toggle.dataset.ready) return;
      toggle.dataset.ready = 'true';
      const header = toggle.closest('.nv-header');
      toggle.addEventListener('click', () => setMobileMenu(header, !header.classList.contains('nv-nav-open')));
    });
    root.querySelectorAll('.nv-menu').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.addEventListener('toggle', () => {
        if (menu.open) document.querySelectorAll('.nv-menu').forEach(other => { if (other !== menu) other.open = false; });
      });
    });
    root.querySelectorAll('.nv-header .nv-nav a').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', () => setMobileMenu(link.closest('.nv-header'), false));
    });
    const motionAllowed = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (motionAllowed && 'IntersectionObserver' in window) document.documentElement.classList.add('nv-motion-ready');
    root.querySelectorAll('[data-nv-reveal]').forEach(item => {
      if (item.dataset.revealReady || !motionAllowed || !('IntersectionObserver' in window)) return;
      item.dataset.revealReady = 'true';
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      observer.observe(item);
    });
    if (motionAllowed && !parallaxBound) {
      parallaxBound = true;
      window.addEventListener('scroll', updateParallax, { passive: true });
      window.addEventListener('resize', updateParallax, { passive: true });
    }
    if (motionAllowed) updateParallax();
  }
  function updateParallax() {
    if (parallaxFrame || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    parallaxFrame = requestAnimationFrame(() => {
      const viewport = window.innerHeight || 1;
      document.querySelectorAll('[data-nv-parallax]').forEach(panel => {
        const image = panel.querySelector('img');
        if (!image) return;
        const rect = panel.getBoundingClientRect();
        const center = rect.top + rect.height / 2;
        const offset = Math.max(-22, Math.min(22, (viewport / 2 - center) / viewport * 34));
        image.style.setProperty('--nv-parallax-y', `${offset.toFixed(1)}px`);
      });
      parallaxFrame = 0;
    });
  }
  function setMobileMenu(header, open) {
    if (!header) return;
    const toggle = header.querySelector('.nv-menu-toggle');
    header.classList.toggle('nv-nav-open', open);
    if (toggle) { toggle.setAttribute('aria-expanded', String(open)); toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); }
    if (!open) header.querySelectorAll('.nv-menu[open]').forEach(menu => { menu.open = false; });
  }
  window.matchMedia('(min-width: 751px)').addEventListener('change', event => {
    if (event.matches) document.querySelectorAll('.nv-header.nv-nav-open').forEach(header => setMobileMenu(header, false));
  });

  let lastCount = null;
  let toastTimer;
  function readCount() { const item = document.querySelector('.nv-cart span'); return item ? Number(item.textContent) || 0 : 0; }
  function showToast() {
    let toast = document.querySelector('.nv-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'nv nv-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
      const text = document.createElement('span'); text.textContent = 'Added to your bag';
      const link = document.createElement('a'); link.className = 'nv-toast-link'; link.textContent = 'View bag →';
      link.href = (window.Shopify?.routes?.root || '/') + 'cart';
      const close = document.createElement('button'); close.type = 'button'; close.className = 'nv-toast-close'; close.setAttribute('aria-label', 'Dismiss'); close.textContent = '×';
      close.addEventListener('click', () => toast.classList.remove('is-visible'));
      toast.append(text, link, close); document.body.appendChild(toast);
    }
    requestAnimationFrame(() => toast.classList.add('is-visible'));
    clearTimeout(toastTimer); toastTimer = setTimeout(() => toast.classList.remove('is-visible'), 5000);
  }
  function refreshCart() {
    const root = window.Shopify?.routes?.root || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(response => response.json()).then(cart => {
      if (lastCount === null) lastCount = readCount();
      document.querySelectorAll('.nv-cart span').forEach(item => { item.textContent = cart.item_count > 0 ? cart.item_count : ''; item.hidden = cart.item_count === 0; });
      const link = document.querySelector('.nv-cart');
      if (cart.item_count > lastCount) {
        if (link) { link.classList.remove('nv-cart-bump'); void link.offsetWidth; link.classList.add('nv-cart-bump'); }
        showToast();
      }
      lastCount = cart.item_count;
    }).catch(() => {});
  }
  document.addEventListener('cart:update', refreshCart);
  window.addEventListener('pageshow', event => { if (event.persisted) { lastCount = null; refreshCart(); } });
  document.addEventListener('click', event => document.querySelectorAll('.nv-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenus = document.querySelectorAll('.nv-menu[open]');
    if (openMenus.length) { openMenus.forEach(menu => { menu.open = false; menu.querySelector('summary')?.focus(); }); return; }
    document.querySelectorAll('.nv-header.nv-nav-open').forEach(header => { setMobileMenu(header, false); header.querySelector('.nv-menu-toggle')?.focus(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
